<script setup>
import RegisterPath1 from '@/components/RegisterPath1.vue'
import RegisterPath2 from '@/components/RegisterPath2.vue'
import SiteHeader from '@/components/SiteHeader.vue'
import SiteFooter from '@/components/SiteFooter.vue'
import { isApp } from '@/helpers/utils.js'
import { IonModal, IonHeader, IonToolbar, IonButtons, IonButton, IonTitle, IonContent, IonPage } from '@ionic/vue'
import { ref, provide, onMounted } from 'vue'
import { onIonViewWillEnter } from '@ionic/vue'


const showModal = ref(true)
const reloadKey = ref(0)
// const isApp = true

// Provide a close function so RegisterPath2 can inject and call it
function closeModal() {
  console.log('closing modal in parent')
  showModal.value = false
}
onMounted(() => {
  // If the app is running in a webview, show the modal
  console.log('onMounted in RegisterForm')
  if (isApp) {
    showModal.value = true
  }
})
provide('closeRegisterModal', closeModal)

// This will fire every time the view is about to enter
onIonViewWillEnter(() => {
  console.log('view enter')
  reloadKey.value += 1 // Increment the key to force re-render of RegisterPath2
  if (isApp) {
    showModal.value = true
  }
})
  // Create a ref to hold the scroll handler function
  const scrollHandler = ref(null)

  // This will be called by ion-content
  const handleScroll = (event) => {
    // Call the handler if one is registered
    console.log('handleScroll called with event:', event)
    if (scrollHandler.value) {
      console.log('Calling registered scroll handler')
      scrollHandler.value(event.detail)
    }
  }
  // Provide a way for nested components to register their handler
  provide('registerScrollHandler', (fn) => {
    scrollHandler.value = fn
  })
</script>

<template>
  <ion-page>
    <ion-content id="loginview" :scroll-events="true" @ionScroll="handleScroll">
      <site-header v-if="isApp === false" :needsReload="true" />
      <template v-if="isApp">
        <ion-modal :is-open="showModal" class="register-modal">
          <ion-content class="register-content">
            <RegisterPath2 />
          </ion-content>
        </ion-modal>
      </template>
      <template v-else>
        <RegisterPath2 :key="reloadKey" />
      </template>
      <site-footer v-if="isApp === false" />
    </ion-content>
  </ion-page>
</template>
